import { render } from "./dondeycuando_ingles.vue?vue&type=template&id=050b0e84&scoped=true"
import script from "./dondeycuando_ingles.vue?vue&type=script&lang=js"
export * from "./dondeycuando_ingles.vue?vue&type=script&lang=js"

import "./dondeycuando_ingles.vue?vue&type=style&index=0&id=050b0e84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050b0e84"]])

export default __exports__